import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const supportApi = createApi({
    reducerPath: 'supportApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_SUPPORT_SERVICE_URL,
        prepareHeaders: (headers) => {
            const { getAccessToken } = require('../../../app/utils/authStorage');
            const token = getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        sendFeedback: builder.mutation({
            query: ({ message, files = [] }) => {
                const formData = new FormData();
                formData.append('message', message);
                for (const f of files) {
                    if (f) formData.append('files', f, f.name || 'file');
                }
                return {
                    url: '/v1/feedback',
                    method: 'POST',
                    body: formData,
                };
            }
        }),
    }),
});

export const { useSendFeedbackMutation } = supportApi;
